// extracted by mini-css-extract-plugin
module.exports = {"immediately":"Highlight_immediately__L5JfH","pulse":"Highlight_pulse__2e5py","shortDelay":"Highlight_shortDelay__1X429","longDelay":"Highlight_longDelay__2X9Ru"};